<template>
    <div class="org-popup-component">
        <div class="global_popup_header">{{title || $t('alertMsg.addList')}}<i @click="$store.commit('windowHandle')"></i></div>
        <div class="org-popup-container">
            <div class="global-body-wrap">  
                <appTable 
                ref="table"
                refName="selectTable"
                tableId="org-popup-table"
                :tableData="tableData"
                :tableProps="tableProps"
                :selectCtrl="true"
                @tableSelection="tableSelection"/>
            </div>
            <pagination
            :pageSize="params.limit"
            :total ="total"
            layout="prev, pager, next"
            @pageNum="getPageNum"
            />
        </div>
        <div class="org-popup-btn">
            <button class="global-button-style" @click="confirm">{{$t('commonMsg.confirm')}}</button>
        </div>
    </div>
</template>

<script>
import appTable from '@/components/appTable'
import pagination from '@/components/pagination'

export default {
    props: {
        title: {
            type: String,
        }
    },
    components: {
        appTable,
        pagination
    },
    computed: {
        tableProps() {
            let tableProps = [{
                prop: 'name',
                label: this.$t('org.orgName'),
            }, {
                prop: 'address',
                label: this.$t('org.area'),
            }, {
                prop: 'fid',
                label: 'FID',
            }]
            return tableProps
        }
    },
    data() {
        return {
            params: {
                limit: 10,
                offset: 0,
            },
            selection:null,
            tableData: [],
            total: 0,
            orgArrIds: []
        }
    },

    methods: {
        getList() {
            this.$http.getOrgList(this.params)
            .then(res => {
                this.tableData = res.data.rows
                this.total = res.data.count
                 this.$nextTick(() => {
                    this.$refs.table.toggleSelection()
                })
            })
        },

        tableSelection(selection) {
            this.selection = selection
        },

        getPageNum(val) {
            this.params.offset = (val - 1) * this.params.limit
            this.getList()
        },

        confirm() {
            this.$emit('getSelection', this.selection)
            this.$store.commit('windowHandle')
        }
    },
    mounted() {
        this.getList()
    }
}
</script>


<style lang="scss" scoped>
    .org-popup-component{
        @include globalPopup(500px, 564px);
        .org-popup-container{
            height:100%;
            display: flex;
            flex-direction: column;
            overflow: hidden;
        }
        .global_popup_header{
            margin-bottom: 0;
        }
        .org-popup-btn{
            border-top:1px solid #ccc;
            padding:10px 20px;
            text-align: right;
            >button {
                width:100px;
            }
        }
    }
</style>
